module.exports = __webpack_public_path__ + "img/bb_g3_t_nose-02.7304b3af.svg";